import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable, filter, switchMap } from 'rxjs';

import { CmsDataService } from '@fcom/core/services/cms/cms-data.service';
import { CmsContent, CmsTeaser } from '@fcom/core-api/interfaces/cms-interface';

/**
 * Used for rendering fragments from CMS whose styling is left entirely to the
 * responsibility of the UX.
 */
@Component({
  selector: 'cms-unstyled-fragment',
  styleUrls: ['./cms-unstyled-fragment.component.scss'],
  templateUrl: './cms-unstyled-fragment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsUnstyledFragmentComponent implements OnInit {
  private cmsDataService = inject(CmsDataService);

  @Input()
  contentUrl$: Observable<string>;
  @Input()
  cmsContent$: Observable<CmsContent>;
  @Input()
  showIcon = false;
  @Input()
  showTitle = true;

  content$: Observable<CmsTeaser>;

  ngOnInit(): void {
    this.content$ = this.cmsContent$
      ? (this.cmsContent$ as Observable<CmsTeaser>)
      : this.contentUrl$.pipe(
          filter(Boolean),
          switchMap((url: string) => this.cmsDataService.getFragmentJson<CmsTeaser>(url))
        );
  }
}
